import React from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Button, IconButton, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { Close as CloseIcon } from "@material-ui/icons";
import { UserContext } from "contexts/UserContext";

const DISMISSED_KEY = "emailConfirmationDismissed";

const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === "1";
  } catch (e) {
    return false;
  }
};

// A gentle reminder (never blocks anything) while the signed-in user's email
// address is unconfirmed. Only an explicit `false` shows it: older cached user
// objects without the field, and everyone who already had an account when
// confirmation was introduced (migration users/0028), count as confirmed.
// Dismissing hides it for the rest of the browser session.
export default () => {
  const { user } = React.useContext(UserContext);
  const location = useLocation();
  const [dismissed, setDismissed] = React.useState(readDismissed);
  // idle | sending | sent | failed
  const [resend, setResend] = React.useState("idle");

  const onConfirmPage = location.pathname.startsWith("/confirm-email/");
  if (!user.isAuthenticated || user.email_verified !== false || dismissed || onConfirmPage) {
    return null;
  }

  const handleResend = () => {
    setResend("sending");
    axios
      .post("/auth/registration/resend-email/", { email: user.email })
      .then(() => setResend("sent"))
      .catch(() => setResend("failed"));
  };

  const handleDismiss = () => {
    try {
      sessionStorage.setItem(DISMISSED_KEY, "1");
    } catch (e) {
      // Private mode: it just comes back on the next page load.
    }
    setDismissed(true);
  };

  const message = {
    idle: `Confirm your email: we sent a link to ${user.email}.`,
    sending: "Sending...",
    sent: "Sent - check your inbox (and spam).",
    failed: "Couldn't send it right now - try again in a little while.",
  }[resend];

  return (
    <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open>
      <Alert
        severity="info"
        action={
          <>
            {(resend === "idle" || resend === "failed") && (
              <Button color="inherit" size="small" onClick={handleResend}>
                Resend
              </Button>
            )}
            <IconButton aria-label="Dismiss" color="inherit" size="small" onClick={handleDismiss}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
